<template>
  <div class="topbar">
    <div class="title">
      ZADIG 运营看板
    </div>
    <div>
      <el-dropdown>
        <span class="el-dropdown-link">
          {{ `${userName.name} (${userName.account})` }}<i
             class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="logout">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userName: {
        name: '',
        account: ''
      },
    }
  },
  methods: {
    async logout() {
      this.$message.success(`退出登录！`)
      this.$utils.clearLoginInfo()
      this.$router.push('/signin')
    }
  },
  created() {
    const info = this.$utils.getLoginInfo()
    this.userName = {
      name: info.name,
      account: info.account
    }
  }
}
</script>

<style lang="less" scoped>
.topbar {
  height: 60px;
  box-shadow: 0 2px 5px #e6e1e1;
  border-bottom: 1px solid #e6e1e1;
  padding: 0 25px;
  display: flex;
  line-height: 60px;
  justify-content: space-between;
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #0066ff;
  }

  .el-dropdown-link {
    font-size: 18px;
    cursor: pointer;
    font-weight: 300;
    &:hover {
      color: #0066ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topbar.vue